import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';

import { AuthorizationRedirectRouteNavigate, AuthorizationRedirectRouteUtils } from './authorization-redirect-route.utils';
import { AuthorizationService } from './authorization.service';

@Injectable()
export class LoggedInRedirectGuardService implements CanActivate {
	constructor(
		private authorizationService: AuthorizationService,
		private router: Router,
	) {
	}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): boolean | Observable<boolean> | Promise<boolean> {

		// return of(true);
		return this.authorizationService.checkLogin()
			.pipe(
				map((checkResult: boolean) => {
					if (checkResult) {
						const navigateRoute: AuthorizationRedirectRouteNavigate = AuthorizationRedirectRouteUtils.getRedirectRoute(route);

						// this.authorizationService.redirectUrl = url;
						// Navigate to the login page with extras
						this.router.navigate([navigateRoute.url], {queryParams: navigateRoute.queryParams});
					}

					return true;
				}),
			);
	}
}
